import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material";
import { FilterCompleteService } from "src/app/filter-complete/filter-complete";
import {
  IFilterComponent,
  SearchFilter,
} from "src/app/infrastructure/iFilter-component";
import { CenterFilter } from "src/app/model/center-filter";
import { EquipmentFilter } from "src/app/model/equipment-filter";
import { PatientSearch } from "src/app/model/patient";
import { PhysicianFilter } from "src/app/model/physician-Filter";
import { PracticeRegionFilter } from "src/app/model/practice-region-filter";
import { ServiceFilter } from "src/app/model/service-filter";
import { FilterRecordService } from "src/app/services/filter-record.service";
import { FilterService } from "src/app/services/filter.service";
import { ReservationService } from "src/app/services/reservation.service";
import { ReportViewerDialogComponent } from "../../dialogs/report-viewer/report-viewer-dialog/report-viewer-dialog.component";
import { MedicalAppointmentAuditingService } from "src/app/services/medical-appointment-auditing/medical-appointment-auditing.service";
import { Entity } from "src/app/model/entity";
import { EntityService } from "src/app/services/entity.service";

@Component({
  selector: "app-medical-appointment-auditing-filter",
  templateUrl: "./medical-appointment-auditing-filter.component.html",
  styleUrls: ["./medical-appointment-auditing-filter.component.css"],
})
export class MedicalAppointmentAuditingFilterComponent
  implements IFilterComponent, OnInit
{
  @ViewChild("formElement", { static: false }) formElement: ElementRef;
  filterCompletePhysicians: FilterCompleteService<PhysicianFilter>;
  filterCompleteServices: FilterCompleteService<ServiceFilter>;
  filterCompletePracticesRegion: FilterCompleteService<PracticeRegionFilter>;
  filterCompleteCenters: FilterCompleteService<CenterFilter>;
  filterCompleteEquipments: FilterCompleteService<EquipmentFilter>;
  filterCompleteEntities: FilterCompleteService<Entity>;
  form: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private filterService: FilterService,
    private dialog: MatDialog,
    private filterRecordService: FilterRecordService,
    private medicalAppointmentAuditingService: MedicalAppointmentAuditingService,
    private reservationService: ReservationService
  ) {
    this.form = this.formBuilder.group({
      DateFrom: [new Date(), [Validators.required]],
      DateTo: [new Date(), [Validators.required]],
      Patient: [null],
      Physician: [""],
      Entity: [""],
      Service: [""],
      Center: [""],
      Equipment: [""],
      PracticeRegion: [""],
      Over: [true],
      Cancel: [false],
      Atended: [false],
      OrderByPatient: [false],
      IsPatientDataValidated: [false],
      IsDocumentationValidated: [false],
      IsMedicalRecordValidated: [false],
      IsProcedureValidated: [false],
      IsReferredToCallCenter: [false],
      OrderByDate: [false],
      WithFiles: [false],
    });

    this.filterCompleteEntities = new FilterCompleteService<Entity>(
      [],
      this.form.controls.Entity
    );

    this.filterCompleteEquipments = new FilterCompleteService<EquipmentFilter>(
      [],
      this.form.controls.Equipment
    );
    this.filterCompleteCenters = new FilterCompleteService<CenterFilter>(
      [],
      this.form.controls.Center
    );
    this.filterCompletePhysicians = new FilterCompleteService<PhysicianFilter>(
      [],
      this.form.controls.Physician
    );
    this.filterCompleteServices = new FilterCompleteService<ServiceFilter>(
      [],
      this.form.controls.Service
    );
    this.filterCompletePracticesRegion =
      new FilterCompleteService<PracticeRegionFilter>(
        [],
        this.form.controls.PracticeRegion
      );
  }

  get filteredEntitiesOptions() {
    return this.filterCompleteEntities
      ? this.filterCompleteEntities.filteredOptions
      : [];
  }

  get filteredEquipmentsOptions() {
    return this.filterCompleteEquipments
      ? this.filterCompleteEquipments.filteredOptions
      : [];
  }
  get filteredCentersOptions() {
    return this.filterCompleteCenters
      ? this.filterCompleteCenters.filteredOptions
      : [];
  }
  get filteredPracticesRegionOptions() {
    return this.filterCompletePracticesRegion
      ? this.filterCompletePracticesRegion.filteredOptions
      : [];
  }
  get filteredPhysiciansOptions() {
    return this.filterCompletePhysicians
      ? this.filterCompletePhysicians.filteredOptions
      : [];
  }
  get filteredServicesOptions() {
    return this.filterCompleteServices
      ? this.filterCompleteServices.filteredOptions
      : [];
  }
  get f() {
    return this.form.controls;
  }

  getSearchFilters(): SearchFilter[] {
    const requiredTags: string[] = [];
    requiredTags.push("DateFrom");
    requiredTags.push("DateTo");
    return this.filterRecordService.convertToSearchFilters(
      this.form,
      requiredTags
    );
  }

  saveFilters(): void {
    this.filterRecordService.saveFilters(
      "MedicalAppointmentAuditingSearchComponent",
      this.form
    );
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters(
      "MedicalAppointmentAuditingSearchComponent",
      this.form
    );
  }

  async search(): Promise<any> {
    return await this.medicalAppointmentAuditingService.getSearchItems(
      <boolean>(
        (this.form.controls.Over.value ? this.form.controls.Over.value : false)
      ),
      <boolean>(
        (this.form.controls.Cancel.value
          ? this.form.controls.Cancel.value
          : false)
      ),
      <boolean>(
        (this.form.controls.Atended.value
          ? this.form.controls.Atended.value
          : false)
      ),
      <boolean>(
        (this.form.controls.OrderByPatient.value
          ? this.form.controls.OrderByPatient.value
          : false)
      ),
      <boolean>(
        (this.form.controls.IsPatientDataValidated.value
          ? this.form.controls.IsPatientDataValidated.value
          : false)
      ),
      <boolean>(
        (this.form.controls.IsDocumentationValidated.value
          ? this.form.controls.IsDocumentationValidated.value
          : false)
      ),
      <boolean>(
        (this.form.controls.IsMedicalRecordValidated.value
          ? this.form.controls.IsMedicalRecordValidated.value
          : false)
      ),
      <boolean>(
        (this.form.controls.IsProcedureValidated.value
          ? this.form.controls.IsProcedureValidated.value
          : false)
      ),
      <boolean>(
        (this.form.controls.IsReferredToCallCenter.value
          ? this.form.controls.IsReferredToCallCenter.value
          : false)
      ),
      <boolean>(
        (this.form.controls.OrderByDate.value
          ? this.form.controls.OrderByDate.value
          : false)
      ),
      <boolean>(
        (this.form.controls.WithFiles.value
          ? this.form.controls.WithFiles.value
          : false)
      ),
      <Date>this.form.controls.DateFrom.value,
      <Date>this.form.controls.DateTo.value,
      this.form.controls.Patient.value
        ? (<PatientSearch>this.form.controls.Patient.value).Id
        : null,
      this.form.controls.Equipment.value
        ? (<EquipmentFilter>this.form.controls.Equipment.value).Id
        : null,
      this.form.controls.Service.value
        ? (<ServiceFilter>this.form.controls.Service.value).Id
        : null,
      this.form.controls.Physician.value
        ? (<PhysicianFilter>this.form.controls.Physician.value).Id
        : null,
      this.form.controls.PracticeRegion.value
        ? (<PracticeRegionFilter>this.form.controls.PracticeRegion.value).Id
        : null,
      null,
      null,
      this.form.controls.Center.value
        ? (<CenterFilter>this.form.controls.Center.value).Id
        : null,
      this.form.controls.Entity.value
        ? (<Entity>this.form.controls.Entity.value).Id
        : null
    );
  }

  async showReport() {
    const reportViewer = await this.reservationService.getReservationReport(
      <boolean>(
        (this.form.controls.Over.value ? this.form.controls.Over.value : false)
      ),
      <boolean>(
        (this.form.controls.Cancel.value
          ? this.form.controls.Cancel.value
          : false)
      ),
      <boolean>(
        (this.form.controls.Atended.value
          ? this.form.controls.Atended.value
          : false)
      ),
      <Date>this.form.controls.DateFrom.value,
      <Date>this.form.controls.DateTo.value,
      this.form.controls.Patient.value
        ? (<PatientSearch>this.form.controls.Patient.value).Id
        : null,
      this.form.controls.Equipment.value
        ? (<EquipmentFilter>this.form.controls.Equipment.value).Id
        : null,
      this.form.controls.Service.value
        ? (<ServiceFilter>this.form.controls.Service.value).Id
        : null,
      this.form.controls.Physician.value
        ? (<PhysicianFilter>this.form.controls.Physician.value).Id
        : null,
      this.form.controls.PracticeRegion.value
        ? (<PracticeRegionFilter>this.form.controls.PracticeRegion.value).Id
        : null,
      null,
      null,
      this.form.controls.Center.value
        ? (<CenterFilter>this.form.controls.Center.value).Id
        : null
    );

    this.dialog.open(ReportViewerDialogComponent, {
      width: "90%",
      height: "600px",
      data: reportViewer,
    });
  }

  async ngOnInit() {
    this.filterCompleteEntities = new FilterCompleteService<Entity>(
      await this.filterService.getEntitiesFilter(),
      this.form.controls.Center
    );

    this.filterCompleteCenters = new FilterCompleteService<CenterFilter>(
      await this.filterService.getCentersFilter(),
      this.form.controls.Center
    );

    this.filterCompleteServices = new FilterCompleteService<ServiceFilter>(
      await this.filterService.getServicesFilter(),
      this.form.controls.Service
    );

    this.filterCompletePhysicians = new FilterCompleteService<PhysicianFilter>(
      await this.filterService.getPhysiciansFilter(),
      this.form.controls.Physician
    );

    this.filterCompletePracticesRegion =
      new FilterCompleteService<PracticeRegionFilter>(
        await this.filterService.getPracticesRegionFilter(),
        this.form.controls.PracticeRegion
      );

    this.filterCompleteEquipments = new FilterCompleteService<EquipmentFilter>(
      await this.filterService.getEquipmentsFilter(),
      this.form.controls.Equipment
    );
  }
}
